import React from 'react';
import * as Styled from './Content.styles';

const Content = ({ contentClass, children }) => (
  <Styled.Content className={contentClass}>{children}</Styled.Content>
);

export default Content;
